import { render, staticRenderFns } from "./file-input-secondary.vue?vue&type=template&id=09586386&scoped=true"
import script from "./file-input-secondary.vue?vue&type=script&lang=js"
export * from "./file-input-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09586386",
  null
  
)

export default component.exports